import './AboutContent.css';
import {Link} from 'react-router-dom';
import react from '../assets/react.jpg';
import node from '../assets/node.jpg';



function AboutContent(){
          return(
                    <div className='about'>
                              <div className='left'>
                                        <h1>Who Am I ?</h1>
                                        <p>I am a final‑year engineering student enrolled in the Information
                                        Technology program at Thadomal Shahani Engineering College, Mumbai.
                                        With a strong passion for software engineering and a keen interest
                                        in web development, I am equipped with skills in ReactJS, Python,
                                        NodeJS, HTML, and CSS. I have gained practical experience through
                                        various projects, including my own Portfolio Application and a MERN
                                        Application.</p>
                                        <Link to='/contact'>
                                                  <button className='btn'>Contact</button>
                                        </Link>

                              </div>

                              <div className='right'>
                                        <div className='img-container'>
                                                  <div className='img-stack top'>
                                                            <img src={react} alt='react' className='img'/>
                                                                                  
                                                  </div>

                                                  <div className='img-stack bottom'>
                                                            <img src={node} alt='node' className='img'/>
                                                  </div>
                                                  
                                        </div>
                              </div>
                    </div>

          )
}

export default AboutContent;